import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { DEFAULT_PATH } from '@/shared/config';
import { BrandLogo, cn } from '@/shared/ui';

interface SidebarBrandProps {
  /** 접힌 아이콘 레일이면 로고 왼쪽 SS 심볼만 보인다. */
  readonly isCollapsed: boolean;
  readonly onNavigate?: () => void;
}

/** 사이드바 맨 위 로고 — 흰 SS 로고와 라임 "ADMIN". 누르면 관리자 첫 화면으로 간다. */
export const SidebarBrand = ({ isCollapsed, onNavigate }: SidebarBrandProps): ReactElement => (
  <Link
    to={DEFAULT_PATH}
    aria-label="관리자 홈"
    onClick={onNavigate}
    className={cn(
      'flex h-16 shrink-0 items-center gap-3 rounded-lg text-white focus-visible:ring-2 focus-visible:ring-white/40 focus-visible:outline-none',
      isCollapsed ? 'justify-center' : 'px-3',
    )}
  >
    {/* 접히면 로고 너비를 심볼(왼쪽 약 36%)만큼만 남겨 워드마크를 가린다. */}
    <span className={cn('block overflow-hidden', isCollapsed && 'w-[30px]')}>
      <BrandLogo className={isCollapsed ? 'h-[22px]' : 'h-7'} />
    </span>
    {isCollapsed ? null : (
      <span className="rounded-full bg-brand-lime px-2 py-0.5 text-[10px] font-bold tracking-[0.1em] text-black">
        ADMIN
      </span>
    )}
  </Link>
);
